<template>
  <!-- 编辑模态框 -->
  <el-dialog title="账单文件导入" :visible.sync="dialogVisible" top="20px">
    <div class="border p-3 rounded">
      <div class="yh-section-title">{{branchOfficeName}}</div>
      <p v-html="tip" class="el-upload__tip" style="line-height: 18px;"></p>
      <!-- <div v-if="company === 'yihe'" >
      <p v-html="tip2" class="el-upload__tip" style="line-height: 18px;"></p>
      <p class="el-upload__tip" style="line-height: 18px;">
      <el-form ref="dataForm" :rules="rules" label-position="right" label-width="300px">
        <el-form-item label="业务关系" prop="selectedCompany">
          <el-select  v-model="selectedCompany" placeholder="请选择导入的公司" @change="handleSelected">
            <el-option
              v-for="item in companyOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      </p></div> -->
      <el-upload ref="upload" class="upload-demo" :multiple="false" :limit="1"
                 action=""
                 :auto-upload=true
                 :accept="accept"
                 :before-upload="handleBeforeUpload"
                 :before-remove="handleBeforeRemove"
                 :headers="headers"
                 :http-request="doImportBillingFile"
                 :on-success="handleUploadSuccess"
                 :on-error="handleUploadError">
        <el-button slot="trigger" size="mini"
                   type="primary">上传账单文件
        </el-button>
      </el-upload>
    </div>
    <div class="mt-3 clearfix">
      <span class="float-right">
        <el-button size="small" type="primary" @click="handleClose">关闭</el-button>
      </span>
    </div>
  </el-dialog>
</template>

<script>
  /* eslint-disable */

  import {getToken} from '@/utils/auth'
  import {importBillingFile} from '@/api/upload'
  import {fetchSettingCompanyList} from '@/api/billing'
  import {error_message} from "@/utils/misc"
  import {EventBus} from "@/utils/event-bus"

  export default {
    name: 'billing-import-dialog',
    props: [
      'company',
      'branchOfficeId',
      'branchOfficeName',
      'branchOfficeCode',
      'companyName',
      'companyCode',
      'billingModel',
      'invocieType'
    ],
    data() {
      return {
        tip: '1. 账单文件必须为<span style="color:red;font-weight:bold" >EXCEL文件(.xls, .xlsx)</span>。<br>' +
             '2. 账单文件第一行<span style="color:red;font-weight:bold" >必须包含标题</span>。<br>' +
             '3. 系统只读账单文件第一页，<span style="color:red;font-weight:bold" >账单数据必须放在第一页</span>。<br>' ,
        tip2: '<span>导入不开票账单需选择对应的保险公司.</span>',
        accept: '.xls,.xlsx',
        temp: {},
        dialogVisible: false,
        // rules: {},
        // companyOptions: [],
        // selectedCompany: null,
        // company_code: null,
        // rules: {
        //   selectedCompany: [{required: true, message: '请输选择要导入的保险公司', trigger: 'blur'}],
        // },
      }
    },
    computed: {
      headers() {
        return {'Authorization': 'Token ' + getToken()}
      }
    },
    methods: {
      // getCompanyOptions() {
      //   fetchSettingCompanyList({})
      //     .then(resp => {
      //       for (let item of resp) {
      //         let option = {}
      //         option['label'] = item.company_name
      //         option['value'] = item.company_code
      //         this.companyOptions.push(option)
      //       }
      //       console.log(this.companyOptions)
      //     }).catch(err => {
      //       this.$error_message(err)
      //     })
      // },
      handleSelected(){
        console.log(this.selectedCompany)
      },
      handleBillingFileImport() {
        // this.selectedCompany = null
        this.dialogVisible = true
      },
      handleClose() {
        this.$refs.upload.clearFiles()
        this.dialogVisible = false
      },
      handleBeforeUpload(file) {
        let uploadFlag = true, processing_file = file
        // const isLt10M = file.size / 1024 / 1024 < 10;

        /*
        if(!isLt10M) {
          this.$message.error(`上传的文件大小不能超过10MB，文件${file.name}大小超出限制`);
          uploadFlag = false;
        }
        */

        // 检查是否重复上传
        this.$refs.upload.uploadFiles
          .filter(file => file.status == 'success')
          .forEach(file => {
            if (file.name == processing_file.name && file.size == processing_file.size) {
              this.$message.warning('文件已经存在，请勿重复上传')
              uploadFlag = false
              return
            }
          })

        return uploadFlag
      },
      handleBeforeRemove(file, filelist) {
        if (file.status == 'success') {
          this.$message.error('已经上传的文件不能删除')
          return false
        }
      },
      handleUploadSuccess(res, file, fileList) {
        this.$message.success(res)
        // EventBus.$emit('import-finished')
        this.$emit('import-finished')
        this.handleClose()
      },
      handleUploadError(error, file, fileList) {
        error_message(error)
        this.$emit('import-finished')
        this.handleClose()
      },
      doImportBillingFile(param) {
        // if (this.company === 'yihe'){
        //   this.$refs['dataForm'].validate(valid => {
        //     if (!valid) {
        //       return
        //     }
        //   })
        // }

        let fileObj = param.file
        let fd = new FormData()
        if (!this.handleBeforeUpload(fileObj)) return

        fd.append('file', fileObj)

        // console.log('this.company :' + this.company)
        // console.log('this.selectedCompany:' + this.selectedCompany)
        // let company_code = this.selectedCompany
        // if (this.company !== 'yihe'){
        //    company_code = this.company
        // }
        console.log('company:' + this.company)
        console.log('branchOfficeId:' + this.branchOfficeId)
        console.log('branchOfficeName:' + this.branchOfficeName)
        console.log('branchOfficeCode:' + this.branchOfficeCode)
        console.log('companyName:' + this.companyName)
        console.log('companyCode:' + this.companyCode)
        console.log('billingModel:' + this.billingModel)
        console.log('invocieType:' + this.invocieType)

        // return
        importBillingFile(fd, this.invocieType, this.companyCode, this.branchOfficeId)
          .then(res => {
            // this.$message.success(res.data.message)
            param.onSuccess(res.message)
            this.handleClose()
          })
          .catch(error => {
            param.onError(error)
          })
      }
    },
    created() {
      // this.getCompanyOptions()
    }
  }
</script>
